<div class="d-flex align-self-center">
  <div *ngFor="let value of [].constructor(maxRating); let i = index;">
    <div (mouseenter)="onMouseEnter(i + 1)" (mouseleave)="onMouseLeave()" (click)="onClick()">
      <fa-icon [icon]="starIcon" [styles]="{'color': '#E8BC00'}" *ngIf="(tempRating >= i + 1)"></fa-icon>
      <fa-icon [icon]="emptyStarIcon" [styles]="{'color': '#E8BC00'}" *ngIf="(tempRating < i + 1)"></fa-icon>
    </div>
  </div>
</div>
